export default __webpack_public_path__ + "static/rebecca1-51ed7482f9cdb99b84084a85d836e21e.jpg";